export default __webpack_public_path__ + "static/media/microphone-2.137ed7cf.svg";